import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {withTranslation} from "react-i18next";
import {Link} from "react-router-dom";

class ButtonContainer extends Component {
    static propTypes = {
        className: PropTypes.string,
        type:      PropTypes.string,
        icon:      PropTypes.string,
        href:      PropTypes.string,
        disabled:  PropTypes.bool,
        loading:   PropTypes.bool,
        loadingText: PropTypes.string,
        onClick:   PropTypes.func.isRequired
    };

    static defaultProps = {
        type: 'button',
        loadingText: null,
        loadingTranslation: 'shared.loading',
        icon: null,
        disabled: false,
        loading: false,
        onClick: () => {},
        href: null
    };

    handleClick(e) {
        const { disabled, loading } = this.props;

        if (disabled || loading) {
            e.preventDefault();
            return;
        }

        this.props.onClick(e);
    }

    render() {
        const { type, icon, disabled, loading, loadingText, t, loadingTranslation, href = null } = this.props;
        const className = cx({
            loading,
            disabled
        }, this.props.className);

        const iconClassName = 'fa fa-fw fa-' + icon;

        if(href != null) {
            return <Link to={href} className={className}>
                {null !== icon && <i className={iconClassName} aria-hidden="true" />}
                {loading ? (loadingText ? loadingText : t(loadingTranslation)+'...') : this.props.children}
            </Link>
        }
        return (
            <button type={type} className={className} onClick={::this.handleClick} disabled={loading || disabled}>
                {null !== icon && <i className={iconClassName} aria-hidden="true" />}
                {loading ? (loadingText ? loadingText : t(loadingTranslation)+'...') : this.props.children}
            </button>
        );
    }
}

export default withTranslation()(ButtonContainer)